const links = $(".reveal__link");
const targets = $(".reveal__target");
const is_open = "is_open";
const is_clicked = "is_clicked";

function handle_click(event) {
	event.preventDefault();
	const shooter = $(this);
	const target = $(shooter.attr("href"));
	const open = $(`.${is_open}`);
	// re-click
	if (shooter.hasClass(is_clicked)) {
		hide_all();
	}
	// something else clicked already
	else if (open.length) {
		hide_all();
		shooter.addClass(is_clicked);
		target.addClass(is_open);
	}
	// nothing clicked previously
	else {
		shooter.addClass(is_clicked);
		target.addClass(is_open);
	}
	hide_outside_click(event);
}

function hide_all() {
	links.removeClass(is_clicked);
	targets.removeClass(is_open);
}

function hide_outside_click(event) {
	const outsideClickListener = (event) => {
		const selector = "header.header";
		const $target = $(event.target);
		if (!$target.closest(selector).length && $(selector).is(':visible')) {
			hide_all();
			removeClickListener();
		}
	}
	const removeClickListener = () => {
		document.removeEventListener('click', outsideClickListener)
	}
	document.addEventListener('click', outsideClickListener)
}

export function init() {
	links.click(handle_click);
}
